<template>
    <div class="sidebar grey darken-4">
      <ul>
        <li class="logo"><img src="./../assets/fyiio-logo.svg" /></li>
        <li><router-link to="/tutorials" class="tutorialsLink" :class="{onTutorialPage}">
        <img src="./../assets/tutorials-active.svg"/></router-link></li>
        <li><a href="/kbs" class="tutorialsLink" :class="{onTutorialPage}">
        <i class="material-icons">flag</i></a></li>
        <li><router-link to="/users"><i class="material-icons">group</i></router-link></router-link></li>
        <li><router-link to="/settings"><i class="material-icons">settings</i></router-link></li>
        <li class="logout"><router-link to="/logout"><i class="material-icons">exit_to_app</i></router-link></li>
      </ul>
      <div v-if="showBanner" class="trial-wrapper">
        <div class="trial-banner container">
            <span class="countdown">Paid plans enable longer video uploads, more support options, custom domains, and more.</span>
            <a href="/settings#plan" class="waves-effect waves-teal btn-flat">UPGRADE</a>
            <a v-on:click="dismissBanner" class="waves-effect waves-teal btn-flat">DISMISS</a>
        </div>
      </div>
      <a id="trialExpiredButton" class="waves-effect waves-light btn modal-trigger" href="#trialExpired">Modal</a>

      <div id="trialExpired" class="modal">
        <div class="modal-content" data-dismissible="false">
          <h4>Trial expired &#x1F614;</h4>
          <p>Your trial expired on {{trial_end}} please select a plan to continue using fyiio and support continued development.</p>
          <p>Shared tutorials are not available until a plan is selected.</p>
          <p>Your content will be deleted in 7 days from when your trial expired.</p>
        </div>
        <div class="modal-footer">
          <!-- <a href="#!" class="modal-close waves-effect waves-green btn-flat">Agree</a> -->
          <router-link to="/settings" class="waves-effect waves-teal btn-flat select-plan">SELECT PLAN</router-link>
        </div>
      </div>
    </div>
</template>

<script>
import GqlQuery from '@/plugins/gql'
import cognitoAuth from '@/plugins/cognito'

export default {
    data () {
      return {
        showBanner: false,
        trial_start_date: false,
        days: 15,
        trial_end: false,
        onTutorialPage: false
      }
    },

    mounted() {
      if (window.location.href.includes('tutorials')) { this.onTutorialPage = true}
      M.AutoInit();
      var self = this;
      document.body.classList.add('has-sidebar')
      cognitoAuth.getUserAttributes(function(err, user_attributes) {
        if (user_attributes['custom:method_of_boarding'] == 'admin') {
          self.checkOrg();
        }
      })
    },

    destroyed() {
        document.body.classList.remove('has-sidebar')
    },
    methods: {
      dismissBanner() {
        this.showBanner = false;
      },
      checkOrg() {
        var self = this;

        GqlQuery.getOrganization( function(err, organization) {
          organization.then((org)=> {
            var user_org = org.data.organizations[0];
            var customer_id = user_org.customer_id
            if ((user_org.plan == null || user_org.plan == 'trial')&& user_org.trial_start_date == null) {
              var orgUpdate = {
                id: user_org.id,
                plan: 'trial',
                plan_status: 'active',
                trial_start_date: new Date()
              };
              GqlQuery.updateOrgAccountDetails(orgUpdate, (err, result) => {
                if (err) {
                } else {
                  result.then((r)=>{
                    console.log("org updated :", r)
                  })
                }
              })
            }
            if (customer_id && customer_id != 'null') {
              self.customer_id = customer_id
            } else if (!window.location.href.match('settings')){
              if (!user_org.trial_start_date) {
                console.log("No trial start, return early.  there should be no banner")
                return;
              }
              self.showBanner = false;
              /*changed to false to support free plan*/
              
            }
          })
        })
      }

    }
}
</script>

<style scoped>
#trialExpiredButton {
  visibility: hidden;
}
.trial-wrapper {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding-left: 100px;

}
.countdown {
  float: left;
  padding: 10px;
}

.trial-banner a{
  margin-top: 5px;
  float: right;
  color: #40abe1;

}
.trial-banner {
    background-color: white;
  color: #58595b;
  border-top: 2px solid gray;
  height: 45px;
}
.sidebar {
  position: fixed;
  left: 0;
  min-height: 100vh;
  min-height: 100%;
  color: white;
  z-index: 1000;;
}
.sidebar .logo {
  border-bottom: 2px solid #929598;
}
.sidebar .logout {
  border-top: 2px solid #929598;
  position: absolute;
  bottom: 0;
}
.sidebar  a {
  color: #929598;
  transition: color 0.2s ease;
}
.sidebar  a:hover, a.router-link-active, a.active {
  color: white;
}
.sidebar li {
  padding: 25px;
  text-align: center;
}
.sidebar i {
  width: 100%;
  font-size: 3em;
}
.tutorialsLink img, .tutorialsLink.router-link-exact-active img {
  opacity: .3;
  transition: opacity 0.2s ease-in-out;
}
.tutorialsLink.router-link-exact-active img,
.onTutorialPage img,
.tutorialsLink:hover img{
  opacity: 1;
}

.modal a, .trial-banner a{
  margin-top: 5px;
  float: right;
  color: #40abe1;
}
.modal a:hover, .trial-banner a:hover{

  color: #40abe1;
}
.modal {
  color: rgba(0, 0, 0, 0.87);
}
.modal h4 {
  font-size: 26px;
}
.modal p {
  color: #7e7e7e;
}
</style>
<style scoped>
#toast-container {
    min-width: 10%;
    top: 100%;
    right: 50%;
    transform: translateX(50%);
    margin-top: -69px;
}
.btn.blue {
  background-color: #27AAE1!important;
}
.btn.blue.disabled {
  background-color: #f1f1f1!important;
}
.blue-text {
  color: #27AAE1!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Sidebar.vue